import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'

class Progress extends PureComponent {
  render() {
    return (
      <div>
        {this.props.loading === false ? null :
          <div>
            <Backdrop style={{ zIndex: '1500' }}
                      open={this.props.loading}>
              <CircularProgress color="inherit" />
            </Backdrop>
          </div>}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.progress.loading
  }
}

const mapDispatchToProps = dispatch => {
  return {

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Progress)